import Vue from 'vue'
import Vuex from 'vuex'
import qudan from './qudan'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        // 显示重量单位
        showUnitType: ''
    },
    getters: {
    },
    mutations: {
        // 给 state 设置数据
        setStateDataFn(store, data) {
            Object.keys(data).forEach(key => store[key] = data[key]);
        },

    },
    actions: {
    },
    modules: {
				qudan
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js